import type { ListCharterReferralParams } from '~/types/charterReferral';

export const charterReferralQueryKeys = {
  all: ['flights-charter', 'fnf-referrals'] as const,
  lists: () => [...charterReferralQueryKeys.all, 'list'] as const,
  list: (filters?: Partial<ListCharterReferralParams>) => [...charterReferralQueryKeys.lists(), filters] as const,
};
